import parse from 'html-react-parser'
import { dateToString } from 'utils/date'

const TextStyles = ({ data, title, timestamp }) => {
  const textoWithLines = data
    .replaceAll('<ol>', '<ol className="list-decimal m-8">')
    .replaceAll('<ul>', '<ul className="list-disc m-8">')
  return (
    <div className="max-w-6xl mx-auto">
      <div className="text-styles mt-10 ml-12 mr-10 mb-20 lg:mx-16 text-blue">
        {title && <h1>{title}</h1>}
        {timestamp && (
          <time
            className="text-xl font-alliance-medium block mb-8"
            dateTime={timestamp}
          >
            {dateToString(timestamp).withYear}
          </time>
        )}
        {parse(textoWithLines)}
      </div>
    </div>
  )
}
export default TextStyles
